import { Box, CircularProgress } from '@mui/material'
import { MutableRefObject, useCallback, useEffect, useRef } from 'react'
import { trackWindowScroll } from 'react-lazy-load-image-component'
import 'swiper/css'
import 'swiper/css/navigation'
import { VodRowViewProps } from '@/types/vod/vodRowType'
import VodItem from '@/features/VOD/vodClasses/vodItem'
import styled from 'styled-components'
import VodRowItemTV from '@/appTV/VOD/components/VodRowItemTV'
import { useVodItemsContext } from '@/features/VOD/context/UseGetVodItemContext/useVodItemsContext'
import {
    FocusContext,
    useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'

const VodRowViewRecommendationsScrollingWrapper = styled.div`
    display: flex;
    overflow-x: hidden;
    overflow-y: hidden;
    flex-shrink: 1;
    flex-grow: 1;
`
const VodRowViewScrollingContent = styled.div`
    display: flex;
    flex-direction: row;
`

const VodRowRecommendationsTVApp = ({
    handleGoToCategoryButtonClick,
    scrollPosition,
    maxHeight,
}: VodRowViewProps) => {
    const itemsContainerRef = useRef<HTMLDivElement>(null)
    const vodItemHeight = maxHeight
    const { recommendationItems, getRecommendationItems, isError, isLoading } =
        useVodItemsContext()

    useEffect(() => {
        const rowElement = itemsContainerRef.current
        getRecommendationItems()

        if (rowElement) {
            rowElement.addEventListener('scroll', () =>
                getRecommendationItems()
            )
            return () =>
                rowElement.removeEventListener('scroll', () =>
                    getRecommendationItems()
                )
        }
    }, [])

    const { ref, focusKey } = useFocusable()

    const scrollingRef: MutableRefObject<HTMLDivElement | null> = useRef(null)

    const onAssetFocus = useCallback(
        ({ x }: { x: number }) => {
            scrollingRef.current?.scrollTo({
                left: x,
                behavior: 'smooth',
            })
        },
        [scrollingRef]
    )

    const rowViewContainerStyle = {
        pt: '2px',
        pb: '76px',
        position: 'relative',
        width: '99%',
    }

    const messageStyle = {
        position: 'absolute',
        left: '50% !important',
        top: ' 50% !important',
        transform: 'translate(-50%, -50%)',
    }

    return (
        <FocusContext.Provider value={focusKey}>
            <Box
                ref={ref}
                onScroll={() => getRecommendationItems()}
                sx={rowViewContainerStyle}>
                {recommendationItems.length && !isError && !isLoading ? (
                    <VodRowViewRecommendationsScrollingWrapper
                        ref={scrollingRef}>
                        <VodRowViewScrollingContent>
                            {recommendationItems.map(
                                (item: VodItem, index: number) => (
                                    <VodRowItemTV
                                        vodItemHeight={vodItemHeight}
                                        item={item}
                                        handleGoToCategoryButtonClick={
                                            handleGoToCategoryButtonClick
                                        }
                                        scrollPosition={scrollPosition}
                                        index={index}
                                        key={index}
                                        onFocusProp={onAssetFocus}
                                        shouldMemorizeLastFocusedItem={false}
                                    />
                                )
                            )}
                        </VodRowViewScrollingContent>
                    </VodRowViewRecommendationsScrollingWrapper>
                ) : (
                    <Box sx={messageStyle}>
                        <CircularProgress color="inherit" />
                    </Box>
                )}
            </Box>
        </FocusContext.Provider>
    )
}

export default trackWindowScroll(VodRowRecommendationsTVApp)
